import { useCallback, useEffect, useState, useMemo } from "react";
import { MetaTags } from "react-meta-tags";
import styled from "styled-components";
import Logo from "../components/Logo/Logo";
import Header from "../components/Header/Header";
import Navigation from "../components/Navigation/Navigation";
import Footer from "../components/Footer/Footer";
import API from "../api";
import { clearLocalStorage, setLocalStorage } from "../utils";
import { RESPONSE_STATUSES } from "../constants";
import AuthSlider from "../components/Slider/AuthSlider";
import ScrollMessage from "../components/ScrollMessage/ScrollMessage";
import PublicHeader from "../screens/Home/comp/Header";
import PublicFooter from "../screens/Home/comp/Footer";

// const StyledAuthMainOuter = styled.section`
//   width: calc(100% - 100px);
//   height: calc(100% - 100px);
//   background-color: #fff3e9;
//   position: fixed;
//   top: 0;
//   left: 0;
//   display: flex;
//   justify-content: center;
//   padding: 50px;
//   @media (max-width: 1000px) {
//     width: 100%;
//     padding: 0px;
//     height: 100%;
//   }
// `;

// const StyledMainSection = styled.section`
//   background-color: rgb(255, 255, 255);
//   box-shadow: 0px 5px 15px -10px #000000;
//   width: 100%;
//   max-width: 1200px;
//   height: auto;
//   margin: 0px;
//   display: flex;
//   flex-direction: row-reverse;
//   column-gap: 30px;
//   padding: 30px;
//   border-radius: 30px;
//   @media (max-width: 1000px) {
//     width: 100%;
//     display: flex;
//     padding: 10px;
//     height: 100% !important;
//     border-radius: 0;
//     justify-content: center;
//     align-items: flex-start;
//   }
// `;

// const StyledAuthHeader = styled.section`
//   width: 100%;
//   height: auto;
//   text-align: center;
//   display: none;
//   @media (max-width: 1000px) {
//     display: flex;
//   }
// `;

// const StyledAuthFormSection = styled.section`
//   width: 50%;
//   height: auto;
//   margin: 0px;
//   padding: 0px;
//   overflow-y: scroll;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   flex-direction: column;
//   @media (max-width: 1000px) {
//     width: 100%;
//   }
//   ::-webkit-scrollbar {
//     display: none;
//   }
// `;

// const StyledAuthFormIn = styled.section`
//   width: 350px;
//   height: 100%;
//   display: ${({ screentype }) => (screentype === "Full" ? "block" : "flex")};
//   flex-direction: column;
//   justify-content: center;

//   @media (max-width: 1000px) {
//     width: 95%;
//     max-width: 350px;
//   }
// `;

// const StyledContentArea = styled.section`
//   width: 60%;
//   height: 100%;
//   img {
//     width: 100%;
//     height: 100%;
//     border-radius: 30px;
//   }
//   @media (max-width: 1000px) {
//     display: none;
//   }
// `;

// New

const StyledAuthContainer = styled.section`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  margin: 0px;
  padding: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  background-color: #ffffff;
`;

const StyledAuthContainerIn = styled.section`
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 30px;
  &::-webkit-scrollbar {
    display: none;
  }
  @media (max-height: 800px) {
    justify-content: flex-start;
  }
      @media (max-width: 1000px) {
    justify-content: flex-start;
  }
`;

const StyledSliderContainerIn = styled.section`
  height: inherit;
  padding: 50px;
`;

const StyledAuthFormContainer = styled.section`
  flex: 2;
  height: inherit;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const StyledAuthHeading = styled.h1`
  font-weight: 800;
  font-size: 40px;
  margin: 10px 0px;
`;

const StyledAuthSubtext = styled.p`
  color: #656565ff;
  text-align: center;
  line-height: 20px;
  margin: 5px 0px;
`;

const StyledFormOuter = styled.section`
  width: 100%;           /* Full width within container */
  max-width: 400px;      /* Prevent overflow on desktop */
  min-width: 0;          /* Allow shrinking on small screens */
  height: auto;
  margin: 0px;
  padding: 0px 16px 40px 16px; /* Responsive padding */
  box-sizing: border-box;

  @media (max-width: 480px) {
    padding: 0 12px 30px 12px;
  }
`;


// display: flex;
//   flex-direction: column;

const StyledAuthSliderContainer = styled.section`
  flex: 3;
  height: inherit;

  @media (max-width: 1000px) {
    display: none;
  }
`;

const StyledSliderOuter = styled.section`
  height: calc(100% - 100px);
  margin: 50px;
  background-color: #fff3e9;
  border-radius: 50px;
`;

const SliderContainer = styled.section`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
const PopupOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(6px); 
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;

  /* Fade-in animation */
  animation: fadeIn 0.3s ease forwards;

  &.fadeOut {
    animation: fadeOut 0.3s ease forwards;
  }

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  @keyframes fadeOut {
    from { opacity: 1; }
    to { opacity: 0; }
  }
`;

const PopupBox = styled.div`
  width: 80%;
  max-width: 600px;
  background: #ffffffdd;
  border-radius: 20px;
  padding: 20px;
  position: relative;
  box-shadow: 0 10px 40px rgba(0,0,0,0.2);

  /* Slide-up */
  animation: slideUp 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);

  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(50px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const PopupCloseButton = styled.button`
  position: absolute;
  top: 15px;
  right: 15px;
  background: #ff4d4d;
  color: #fff;
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  cursor: pointer;
  font-size: 20px;
  line-height: 0;
  display: flex;
  justify-content: center;
  align-items: center;

  transition: 0.25s ease;
  &:hover {
    background: #ff2e2e;
    transform: scale(1.12);
  }
`;


export const AuthIntro = styled.div`
  margin-top: 12px;
  text-align: center;
  width: 100%;
`;

export const AuthTitle = styled.h2`
  font-size: 26px;
  font-weight: 700;
  margin: 0;
  color: #0f172a;

  @media (max-width: 480px) {
    font-size: 22px;
  }
`;

export const AuthSubtitle = styled.p`
  font-size: 14px;
  margin-top: 6px;
  color: #475569;
  line-height: 1.5;

  @media (max-width: 480px) {
    font-size: 13px;
  }
`;

// const widthAuthHOC = (Component, isLogin) => (props) => {
//   console.log(isLogin)

//   const { appName, appLogo, bannerImages } = props.appData;

//   const sliderImages =
//     (bannerImages &&
//       bannerImages.length > 0 &&
//       bannerImages?.filter((i) => i.type === "Authentication")) ||
//     [];


//   return (
//     <StyledAuthContainer>
//       <StyledAuthFormContainer>
//         <StyledAuthContainerIn>
//           <Logo appName={appName} appLogo={'/logo.png'} isAuth />
//           {isLogin && (<>
//           <StyledAuthHeading>Welcome back!</StyledAuthHeading>
//           <StyledAuthSubtext>
//             Boost your income with India's most trusted recharge platform
//           </StyledAuthSubtext>
//           </>)}
//           <StyledFormOuter>
//             <Component {...props} />
//           </StyledFormOuter>
//         </StyledAuthContainerIn>
//       </StyledAuthFormContainer>
//       <StyledAuthSliderContainer>
//         <StyledSliderOuter>
//           <AuthSlider images={sliderImages} />
//         </StyledSliderOuter>
//       </StyledAuthSliderContainer>
//     </StyledAuthContainer>
//     // <StyledAuthMainOuter>
//     //   <StyledMainSection>
//     //     <StyledAuthFormSection>
//     //       <StyledAuthHeader>
//     //         <Logo appName={appName} appLogo={appLogo} />
//     //       </StyledAuthHeader>
//     //       <StyledAuthFormIn screentype={screenType}>
//     //         <Component {...props} />
//     //       </StyledAuthFormIn>
//     //     </StyledAuthFormSection>
//     //     <StyledContentArea>
//     //       <img src={appLogo} alt={appName} />
//     //     </StyledContentArea>
//     //   </StyledMainSection>
//     // </StyledAuthMainOuter>
//   );
// };



// const widthAuthHOC = (Component, isLogin) => (props) => {

//   const { appName, appLogo, bannerImages } = props.appData;

//   const [showSliderPopup, setShowSliderPopup] = useState(false);
//   const [sliderAutoPlay, setSliderAutoPlay] = useState(true);
//   const [closing, setClosing] = useState(false);

//   // Ensure sliderImages is always an array
//   const sliderImages =
//     bannerImages?.filter((i) => i.type === "Authentication") || [];

//   // Open popup only if:
//   // 1. First visit
//   // 2. Images available
//   useEffect(() => {
//     const hasSeenPopup = localStorage.getItem("seenAuthPopup");

//     if (!hasSeenPopup && sliderImages.length > 0) {
//       setShowSliderPopup(true);
//       localStorage.setItem("seenAuthPopup", "true");
//       document.body.style.overflow = "hidden"; // Lock scroll
//     }
//   }, [sliderImages]);

//   const closePopup = () => {
//     setClosing(true); // trigger fadeOut

//     setTimeout(() => {
//       setSliderAutoPlay(false);
//       setShowSliderPopup(false);
//       setClosing(false);
//       document.body.style.overflow = "auto"; // Unlock scroll
//     }, 300); // fadeOut duration
//   };

//   return (
//     <StyledAuthContainer>

//       {/* Auth Form */}
//       <StyledAuthFormContainer>
//         <StyledAuthContainerIn>

//           <Logo appName={appName} appLogo="/logo.png" isAuth />

//           {isLogin && (
//             <AuthIntro>
//               <AuthTitle>Welcome back!</AuthTitle>
//               <AuthSubtitle>
//                 Power up your income with most trusted recharge marketplace.
//               </AuthSubtitle>
//             </AuthIntro>
//           )}

//           <StyledFormOuter>
//             <Component {...props} />
//           </StyledFormOuter>

//         </StyledAuthContainerIn>
//       </StyledAuthFormContainer>


//       {/* Popup Slider */}
//       {showSliderPopup && sliderImages.length > 0 && (
//         <PopupOverlay className={closing ? "fadeOut" : ""}>
//           <PopupBox>
//             <PopupCloseButton onClick={closePopup}>×</PopupCloseButton>
//             <AuthSlider images={sliderImages} autoPlay={sliderAutoPlay} />
//           </PopupBox>
//         </PopupOverlay>
//       )}

//     </StyledAuthContainer>
//   );
// };

const widthAuthHOC = (Component, isLogin) => (props) => {
  const { appName, appLogo, bannerImages } = props.appData;

  const [showSliderPopup, setShowSliderPopup] = useState(false);
  const [sliderAutoPlay, setSliderAutoPlay] = useState(true);
  const [closing, setClosing] = useState(false);

  const sliderImages =
    bannerImages?.filter((i) => i.type === "Authentication") || [];

  useEffect(() => {
    const hasSeenPopup = localStorage.getItem("seenAuthPopup");
    if (!hasSeenPopup && sliderImages.length > 0) {
      setShowSliderPopup(true);
      localStorage.setItem("seenAuthPopup", "true");
      document.body.style.overflow = "hidden";
    }
  }, [sliderImages]);

  const closePopup = () => {
    setClosing(true);
    setTimeout(() => {
      setSliderAutoPlay(false);
      setShowSliderPopup(false);
      setClosing(false);
      document.body.style.overflow = "auto";
    }, 300);
  };

  return (
    <StyledAuthContainer>

      {/* Auth Form */}
      <StyledAuthFormContainer>
        <StyledAuthContainerIn>

          <Logo appName={appName} appLogo="/logo.png" isAuth />

          {isLogin && (
            <AuthIntro>
              <AuthTitle>Welcome back!</AuthTitle>
              <AuthSubtitle>
                Power up your income with most trusted recharge marketplace.
              </AuthSubtitle>
            </AuthIntro>
          )}

          <StyledFormOuter>
            <Component {...props} />
          </StyledFormOuter>

        </StyledAuthContainerIn>
      </StyledAuthFormContainer>

      {/* Popup Slider */}
      {showSliderPopup && sliderImages.length > 0 && (
        <PopupOverlay className={closing ? "fadeOut" : ""}>
          <PopupBox>
            <PopupCloseButton onClick={closePopup}>×</PopupCloseButton>
            <AuthSlider images={sliderImages} autoPlay={sliderAutoPlay} />
          </PopupBox>
        </PopupOverlay>
      )}
    </StyledAuthContainer>
  );
};



const withAppHOC = (Component) => (props) => {
  const [profile, setProfile] = useState(null);
  const [scrollMessage, setScrollMessage] = useState("");
  const [showNav, setShowNav] = useState(false);

  const readScrollMessage = useCallback(async () => {
    const response = await API.get("/meta/scroll-message");
    const { status, data } = response.data;
    if (status === RESPONSE_STATUSES.SUCCESS) {
      setScrollMessage(data);
    }
  }, []);

  const readProfile = useCallback(async () => {
    const response = await API.get("/authentication/profile");
    const { status, data } = response.data;
    if (status === RESPONSE_STATUSES.SUCCESS) {
      setProfile(data);
      setLocalStorage("userProfile", JSON.stringify(data));
    }
  }, []);

  const onClickLogout = (e) => {
    e.preventDefault();
    API.delete("/authentication/logout");
    clearLocalStorage();
    window.location.href = "/login";
  };

  const onClickNavigationIcon = () => {
    setShowNav((showNav) => !showNav);
  };

  useEffect(() => {
    readProfile();
    readScrollMessage();
  }, [readProfile, readScrollMessage]);

  return (
    <>
      <Header
        fullName={profile?.firstName ? profile.firstName : "My Account"}
        {...profile}
        onClickLogout={onClickLogout}
        showNav={showNav}
        setShowNav={onClickNavigationIcon}
        {...props}
      />
      <Navigation {...props} showNav={showNav} />
      <ScrollMessage scrollMessage={scrollMessage} />
      <Component {...props} />
      <Footer {...props} />
    </>
  );
};

const withPublicHOC =
  (Component) =>
    ({ appData }) => {
      return (
        <>
          <MetaTags>
            <link
              href="https://fonts.googleapis.com/css?family=Poppins:200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i&display=swap"
              rel="stylesheet"
            />

            <link rel="stylesheet" href="css/bootstrap.min.css" />
            <link rel="stylesheet" href="css/normalize.css" />
            <link rel="stylesheet" href="css/style.css" />
            <link rel="stylesheet" href="css/responsive.css" />
            <link rel="stylesheet" href="css/color/color1.css" />
            <link rel="stylesheet" id="colors" />
          </MetaTags>
          <PublicHeader {...appData} />
          <Component {...appData} />
          <PublicFooter {...appData} />
          <script src="js/jquery.min.js"></script>
          <script src="js/bootstrap.min.js"></script>
          <script src="js/main.js"></script>
        </>
      );
    };

export { widthAuthHOC, withAppHOC, withPublicHOC };
